<template>
    <div style="overflow-x: hidden;">
        <div class="col-12 mx-auto">
            <p class="mb-0 fts-18 pl-3 h-emphasis" style="font-weight: 900;">Détail du portefeuille</p>
        </div>
        <div class="col-12 mx-auto py-3">
            <table class="mr-auto" style="width: 50%;">
                <thead>
                    <tr>
                        <th class="px-2" style="width: 50%;">
                            <input type="text"
                                style="font-size: 11px; width: 100%; border: none; border-radius: 5px; background-color: rgb(30, 30, 30); padding: 5px; color: rgba(255, 255, 255, .6);"
                                placeholder="Rechercher le secteur"
                                v-model="filtersector"
                                @change="onFilterSectorChange()">
                        </th>
                        <th class="px-2" style="width: 50%;">
                            <input type="text"
                                style="font-size: 11px; width: 100%; border: none; border-radius: 5px; background-color: rgb(30, 30, 30); padding: 5px; color: rgba(255, 255, 255, .6);"
                                placeholder="Rechercher le nom d'un fond"
                                v-model="filtername"
                                @change="onFilterNameChange()">
                        </th>
                    </tr>
                </thead>
            </table>
        </div>
        <div class="row mx-auto pt-0 mb-5 pb-3">
            <table class="myfotable-dark">
                <colgroup>
                    <col style="width: 20%;">
                    <col style="width: 20%;">
                    <col style="width: 15%;">
                    <col style="width: 15%;">
                    <col style="width: 15%;">
                    <col style="width: 15%;">
                </colgroup>
                <thead>
                    <tr style="background-color: rgba(38, 42, 62, .05);">
                        <th class="py-3 text-left pl-3">
                            <div style="display: inline-block;">
                                Secteur
                            </div>
                            <div style="display: inline-block;">
                                <button
                                    style="text-align:center;"
                                    type="button"
                                    id="sort"
                                    class="fas fa-caret-up"
                                    aria-label="Tri ascendant"
                                    v-on:click="sectorSortAsc">
                                </button>
                            </div>
                            <div style="display: inline-block;">
                                <button
                                    style="text-align:center"
                                    type="button"
                                    id="sort"
                                    class="fas fa-caret-down"
                                    aria-label="Tri descendant"
                                    v-on:click="sectorSortDsc">
                                </button>
                            </div>
                        </th>
                        <th class="text-left">
                            <div style="display: inline-block;">
                                Position
                            </div>
                            <div style="display: inline-block;">
                                <button
                                    style="text-align:center;"
                                    type="button"
                                    id="sort"
                                    class="fas fa-caret-up"
                                    aria-label="Tri ascendant"
                                    v-on:click="positionSortAsc">
                                </button>
                            </div>
                            <div style="display: inline-block;">
                                <button
                                    style="text-align:center"
                                    type="button"
                                    id="sort"
                                    class="fas fa-caret-down"
                                    aria-label="Tri descendant"
                                    v-on:click="positionSortDsc">
                                </button>
                            </div>
                        </th>
                        <th>Montant (€)</th>
                        <th>Nombre de parts</th>
                        <th class="text-left">Frais</th>
                        <th>Décomposition</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(comparison, index) in customs" :key="index">
                        <td class="py-3 text-left">
                            <p class="mb-0 pl-2">{{ comparison.security.sector.name_french }}</p>
                        </td>
                        <td class="text-left">
                            <div class="font-weight-bold pb-2" style="color: rgb(187, 134, 252)">
                                {{ comparison.security.name }}
                            </div>
                            <div>
                                ISIN : <span style="background-color: rgba(187, 134, 252, .1); color: rgb(187, 134, 252); padding: 2px; border-radius: 5px">{{ comparison.security.isin }}</span>
                            </div>
                        </td>
                        <td>
                            {{ Math.round(comparison.amount,0) }}
                        </td>
                        <td>
                            {{ Math.round(comparison.number_shares,0) }}
                        </td>
                        <td v-if="comparison.fees" class="text-left font-weight-bold">
                            <div style="line-height: 2em;">
                                Frais de gestion : <span style="background-color: rgba(187, 134, 252, .1); color: rgb(187, 134, 252); padding: 2px; border-radius: 5px;">{{ Math.round(comparison.security.management_fees*100,0)/100 }} %</span>
                            </div>
                            <div style="line-height: 2em;">
                                Frais d'entrée : <span style="background-color: rgba(187, 134, 252, .1); color: rgb(187, 134, 252); padding: 2px; border-radius: 5px;">{{ Math.round(comparison.security.entry_fees*100,0)/100 }} %</span>
                            </div>
                        </td>
                        <td v-else class="text-left font-weight-bold">
                        </td>
                        <td v-if="comparison.is_lookthrough">
                            <button class="btn-alt-2" v-b-modal="modalId(comparison.security.isin+' '+comparison.contract)">
                                Décomposition
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-plus-circle ml-1" style= "margin-bottom: 2px;" viewBox="0 0 16 16">
                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                    <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                                </svg>
                            </button>
                            <b-modal
                                :title="'La décomposition de votre allocation'+comparison.name"
                                class="modal fade alt-list" :id="'modal' + comparison.isin+' '+comparison.contract"
                                tabindex="-1"
                                role="dialog"
                                size="xl"
                                aria-labelledby="alternatives"
                                aria-hidden="true"
                                :header-bg-variant="headerBgVariant"
                                :header-text-variant="headerTextVariant"
                                :body-bg-variant="bodyBgVariant"
                                :body-text-variant="bodyTextVariant"
                                :footer-bg-variant="footerBgVariant"
                                :footer-text-variant="footerTextVariant"
                                ok-only
                                >
                                <div style="display: contents;">
                                    <table class="myfotable-dark">
                                        <colgroup>
                                            <col style="width: 30%;">
                                            <col style="width: 10%;">
                                            <col style="width: 20%;">
                                            <col style="width: 10%;">
                                            <col style="width: 10%;">
                                            <col style="width: 10%;">
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th style="text-align: left;">Titre</th>
                                                <th>ISIN</th>
                                                <th>Secteur</th>
                                                <th>Pays</th>
                                                <th>Devise</th>
                                                <th>Poids</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(alternative, index) in comparison.security_lookthrough" :key="index">
                                                <div v-if="alternative.name === 'myfo rocks'" style="display: contents;" id="random">
                                                    <td style="font-weight: bold; color: rgb(187, 134, 252); text-align: left;">
                                                        <div class='blurry'>
                                                            {{ alternative.security.name }}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div class='blurry-white'>
                                                            {{ alternative.security.isin }}
                                                        </div>
                                                    </td>
                                                    <td>{{ alternative.security.sector }}</td>
                                                    <td>{{ alternative.country }}</td>
                                                    <td>{{ alternative.currency }}</td>
                                                    <td style="font-weight: bold;">{{ Math.round(alternative.weight*10000)/100 }} %</td>
                                                </div>
                                                <div v-else style="display: contents;">
                                                    <td style="font-weight: bold; color: rgb(187, 134, 252); text-align: left;">{{ alternative.name }}</td>
                                                    <td>{{ alternative.isin }}</td>
                                                    <td>{{ alternative.sector }}</td>
                                                    <td>{{ alternative.country }}</td>
                                                    <td>{{ alternative.security.currency }}</td>
                                                    <td style="font-weight: bold;">{{ Math.round(alternative.weight*10000)/100 }} %</td>
                                                </div>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div v-if="access === false" class="text-center mt-4">
                                        <p class="light-white-02">Passez à la version premium pour accéder aux détails de vos positions</p>
                                        <button class="btn-transparncy m-3"><a :href="'/app/home/payment/portal'">Upgrader</a></button>
                                    </div>
                                </div>
                            </b-modal>
                        </td>
                        <td v-else>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'comparisons',
            'access_granted',
            'token',
            'route',
        ],

        data() {
            return {
                customs:[],
                filtername:"",
                access:"",
                filtersector:"",
                show: false,
                variants: ['primary', 'secondary', 'success', 'warning', 'danger', 'info', 'light', 'dark'],
                headerBgVariant: 'info',
                headerTextVariant: 'light',
                bodyBgVariant: 'dark',
                bodyTextVariant: 'dark',
                footerBgVariant: 'info',
                footerTextVariant: 'dark'
            }
        },

        mounted() {
            this.comparisons.forEach(comparison =>
            {
                this.customs.push(comparison)
            });
            this.access = this.accessgranted;
        },


        methods: {
            onFilterNameChange(){
                this.customs=[];
                this.comparisons.forEach(comparison =>
                {
                    if (comparison.name.toLowerCase().includes(this.filtername.toLowerCase()))
                    {
                        this.customs.push(comparison);
                    }
                });

            },
            modalId(i) {
            return 'modal' + i;
            },
            onFilterSectorChange(){
                this.customs=[];
                this.comparisons.forEach(comparison =>
                {
                    if (comparison.sector.toLowerCase().includes(this.filtersector.toLowerCase()))
                    {
                        this.customs.push(comparison);
                    }
                });

            },
            sectorSortAsc(){

                this.customs = this.customs.sort(function(a, b){
                    if (a.sector < b.sector)
                    {
                        return -1;
                    }
                    else if (a.sector > b.sector)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },

            sectorSortDsc(){
                this.customs = this.customs.sort(function(a, b){
                    if (a.sector > b.sector)
                    {
                        return -1;
                    }
                    else if (a.sector < b.sector)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            positionSortAsc(){
                this.customs = this.customs.sort(function(a, b){
                    if (a.name < b.name)
                    {
                        return -1;
                    }
                    else if (a.name > b.name)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            positionSortDsc(){
                this.customs = this.customs.sort(function(a, b){
                    if (a.name > b.name)
                    {
                        return -1;
                    }
                    else if (a.name < b.name)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            isinSortAsc(){
                this.customs = this.customs.sort(function(a, b){
                    if (a.isin < b.isin)
                    {
                        return -1;
                    }
                    else if (a.isin > b.isin)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            isinSortDsc(){
                this.customs = this.customs.sort(function(a, b){
                    if (a.isin > b.isin)
                    {
                        return -1;
                    }
                    else if (a.isin < b.isin)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            savingSortAsc(){
                this.customs = this.customs.sort(function(a, b){
                    if (a.saving < b.saving)
                    {
                        return -1;
                    }
                    else if (a.saving > b.saving)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            savingSortDsc(){
                this.customs = this.customs.sort(function(a, b){
                    if (a.saving > b.saving)
                    {
                        return -1;
                    }
                    else if (a.saving < b.saving)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
    }
}

</script>